import PropTypes from "prop-types";
import { CircularProgress, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { CheckCircleOutline, ErrorOutline } from "@mui/icons-material";
import { readerDialogPaper } from "./DeviceActionDialog";
export default function ProcessingDialog({ open, message = "Procesando…" }) {
  const success = message.startsWith("✅");
  const error = message.startsWith("❌");
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{ sx: readerDialogPaper }}
      aria-label="Estado de la operación"
    >
      <DialogContent sx={{ p: 4 }}>
        <Stack role="status" aria-live="polite" alignItems="center" gap={2}>
          {success ? (
            <CheckCircleOutline sx={{ fontSize: 40, color: "#237849" }} />
          ) : error ? (
            <ErrorOutline sx={{ fontSize: 40, color: "#b33f4c" }} />
          ) : (
            <CircularProgress size={36} />
          )}
          <Typography variant="body1" fontWeight={600} textAlign="center" sx={{ color: "#243b53" }}>
            {message.replace(/^[✅❌📊📈]\s*/u, "")}
          </Typography>
          {!success && !error && (
            <Typography variant="body2" textAlign="center" sx={{ color: "#526579" }}>
              Espera mientras se prepara el informe.
            </Typography>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
ProcessingDialog.propTypes = { open: PropTypes.bool.isRequired, message: PropTypes.string };
